import { t } from '@lingui/macro'
import { useState } from 'react'

import { Heading, Space, Text } from '@/components'

import { ComponentTypes } from '../types'
import Login from './Login'
import Signup from './Signup'

enum ApplyMode {
  SIGNUP = 'signup',
  LOGIN = 'login',
}

const Profile: React.FC<React.PropsWithChildren<ComponentTypes>> = ({ nextStep }) => {
  const [mode, setMode] = useState<ApplyMode>(ApplyMode.SIGNUP)

  const content: {
    [key: string]: {
      description: string
      button: string
      setModeTo: ApplyMode
      Component: React.FC<React.PropsWithChildren<{ nextStep: () => void }>>
    }
  } = {
    [ApplyMode.SIGNUP]: {
      description: t`Do you already have an account?`,
      button: t`Sign in`,
      setModeTo: ApplyMode.LOGIN,
      Component: Signup,
    },
    [ApplyMode.LOGIN]: {
      description: t`You don’t have an account?`,
      button: t`Sign up`,
      setModeTo: ApplyMode.SIGNUP,
      Component: Login,
    },
  }

  const { description, button, setModeTo, Component } = content[mode]

  return (
    <>
      <Space y={2}>
        <Heading level={2} variant={TextStyle => TextStyle.MEDIUM_LG_NORMAL}>
          {t`Tell us more about yourself`}
        </Heading>

        <Text className="text-grey-dark">
          {description}{' '}
          <button className="font-medium underline" onClick={() => setMode(setModeTo)}>
            {button}
          </button>
        </Text>
      </Space>

      <Space y={12} />

      <Component nextStep={nextStep} />
    </>
  )
}

export default Profile
